import React from 'react';
import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {Grid} from '@/content/features/shared';
import {SectionPaddingHalf} from '@/section';
import PictureWrapper from '@/ui/images-wrapper';
import {withBoldWeight} from '@/hocs/withFontType';
import styles from './styles.module.scss';

const Span = (props: React.HTMLAttributes<HTMLSpanElement>) => <span {...props} />;
const BoldSpan = withBoldWeight(Span);

const imgPath = '/static/images/customers/';

const SingleTestimonial = () => {
  const t = useTranslations('customers.singleTestimonial');

  return (
    <SectionPaddingHalf>
      <Container>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <figure className={styles.testimonial}>
                <PictureWrapper
                  imgPath={imgPath}
                  imageUrl="gould-rantner-logo"
                  imageTypeFallback="png"
                  altImage={t('logoAlt')}
                  loading="lazy"
                />
                <blockquote className={styles.testimonial__quote}>{t('quote')}</blockquote>
                <figcaption className={styles.testimonial__byline}>
                  {t.rich('byLine', {strong: chunks => <BoldSpan>{chunks}</BoldSpan>})}
                </figcaption>
              </figure>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionPaddingHalf>
  );
};

export default SingleTestimonial;
